module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary",
      "dark": "",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/empresa/new",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/admin/empresa",
      "router": "",
      "icon": "icon"
    }
  }, [_c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('form', {
    attrs: {
      "validate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-card-text', [_c('EmpresaForm', {
    attrs: {
      "empresa": _vm.empresa
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('div', {}, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "ripple": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "dark": "",
      "ripple": ""
    }
  }, [_vm._v("Gravar")])], 1)])], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cdd9e8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmpresaEdit.vue
// module id = 361
// module chunks = 1